module.exports = __webpack_public_path__ + "static/media/russian-flag.ea119ef2.svg";